import React from 'react';

// from https://stackoverflow.com/questions/38212174/is-it-possible-to-pass-context-into-a-component-instantiated-with-reactdom-rende
function createContextProvider(context) {
  class ContextProvider extends React.Component {
    getChildContext() {
      return context;
    }

    render() {
      return this.props.children;
    }
  }

  ContextProvider.childContextTypes = {};
  Object.keys(context).forEach((key) => {
    ContextProvider.childContextTypes[key] = React.PropTypes.any.isRequired;
  });

  return ContextProvider;
}

export default createContextProvider;
